import { useLocation } from 'react-router-dom';


export const ROUTE_PATTERNS = {
  PUBLIC_ONBOARDING: '/onboarding/',
  ONBOARDING_FORM: '/onboarding-form/',
  CLIENT: '/clients/',
  RESULTS_ARE_IN: '/onboarding/results-are-in',
  PUBLIC_ONBOARD: '/onboard/',
} as const;

export function isPublicOnboardingPath(path: string): boolean {
  return (
    path.startsWith(ROUTE_PATTERNS.PUBLIC_ONBOARDING) &&
    !path.startsWith(ROUTE_PATTERNS.ONBOARDING_FORM)
  );
}

export function isClientPath(path: string): boolean {
  return path.includes(ROUTE_PATTERNS.CLIENT);
}

export function isResultsAreInPath(path: string): boolean {
  return path.includes(ROUTE_PATTERNS.RESULTS_ARE_IN);
}

export function isPublicOnboardPath(path: string): boolean {
  return path.startsWith(ROUTE_PATTERNS.PUBLIC_ONBOARD);
}

export function useClientRoutes() {
  const location = useLocation();
  const { pathname } = location;

  const isClientOnboardingRoute = isClientPath(pathname) && pathname.includes('/onboarding/');

  return {
    pathname,
    isPublicOnboardingRoute: isPublicOnboardingPath(pathname),
    isClientRoute: isClientPath(pathname),
    isResultsAreInPage: isResultsAreInPath(pathname),
    isClientOnboardingRoute,
  };
}

